<template>
  <v-navigation-drawer
    v-bind="$attrs"
    v-on="$listeners"
    v-model="drawer"
    :app="app"
    :right="right"
    :clipped="clipped"
    :width="width"
    :color="$vuetify.theme.dark ? ADS_Colors.DP01 : ADS_Colors.White"
    :temporary="temporary"
  >
    <FocusTrap :is-active="drawer">
      <div class="drawer__wrapper">
        <v-card
          flat
        >
          <v-card-title
            class="d-flex py-4 pr-1"
          >
            <FeatureIcon
              v-if="icon"
              size="40"
              :icon="icon"
              class="icon"
            />
            <h1
              ref="preFocus"
              role="heading"
              class="title ml-4"
              tabindex="-1"
            >
              {{ heading }}
            </h1>
            <v-spacer />
            <v-btn
              aria-label="close notifications"
              @click="closeDrawer"
              @keyup.enter="closeDrawer"
              size="18"
              class="size--40"
              icon
            >
              <v-icon
                size="18"
                :color="ADS_Colors.Dark_60"
                class="material-icons-outlined"
              >
                close
              </v-icon>
            </v-btn>
          </v-card-title>

          <v-divider
            class="divider"
          />

          <v-card-text
            class="pa-0"
          >
            <slot name="content" />
          </v-card-text>
        </v-card>
      </div>
    </FocusTrap>
  </v-navigation-drawer>
</template>

<script>
import FeatureIcon from '../FeatureIcon';
import FocusTrap from '../FocusTrap';
import {ADS_Colors} from '../ads-colors';

export default {
  name: 'AdsDrawer',
  components: {
    FocusTrap,
    FeatureIcon
  },
  props: {
    app: {
      type: Boolean,
      default: true   // override the default value 'false' in v-navigation-drawer
    },
    right: {
      type: Boolean,
      default: true   // override the default value 'false' in v-navigation-drawer
    },
    width: {
      type: [Number, String],
      default: '360'  // override the default value '256' in v-navigation-drawer
    },
    clipped: {
      type: Boolean,
      default: true   // override the default value 'false' in v-navigation-drawer
    },
    temporary: {
      type: Boolean,
      default: true   // override the default value 'false' in v-navigation-drawer
    },
    icon: {
      type: String,
      default: ''
    },
    heading: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ADS_Colors
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$attrs.value;
      },
      set(value) {
        this.$listeners.input && this.$listeners.input(value);
      }
    }
  },
  watch: {
    drawer(val) {
      if (!val) { // false, close the drawer
        this.showMainScrollbar();
      } else {    // true, open the drawer
        setTimeout(() => this.$refs.preFocus?.focus());
        this.hideMainScrollbar();
      }
    }
  },
  methods: {
    closeDrawer() {
      this.drawer = false;
    },
    hideMainScrollbar() {
      const styleForScrollbar = document.createElement('style');
      styleForScrollbar.id = 'style-for-scrollbar';
      styleForScrollbar.innerHTML = 'html::-webkit-scrollbar { display: none; } html { -ms-overflow-style: none; scrollbar-width: none; padding-right: 16px; }';
      document.head.appendChild(styleForScrollbar);
    },
    showMainScrollbar() {
      const styleForScrollbar = document.getElementById('style-for-scrollbar');
      if (styleForScrollbar) {
        document.head.removeChild(styleForScrollbar);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.drawer__wrapper {
  overflow: hidden;

  .icon-info {
    background-color: $ads-light-blue;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
  }

  .divider {
    top: 70px;
    z-index: 1000;
    overflow: hidden;
    width: 100%;
    opacity: 1;
    border-color: $ads-light-40;
  }

  .size--40 {
    width: 40px;
    height: 40px
  }
}

.v-overlay__scrim {
  opacity: 0 !important;
}

.v-overlay v-overlay--active {
  z-index: 0 !important;
}
</style>
